import React from 'react';

export const FontIcon = props =>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="10.812"
    height="13"
    viewBox="0 0 10.812 13"
    style={{
      fillRule: 'evenodd',
    }}
    {...props}
  >
    <path
      d="M845.033,853.713H834.486v3.078h1.045a0.4,0.4,0,0,0,.417-0.342c0.018-.108.052-0.36,0.089-0.756h2.65v9.255c-0.218.036-.4,0.072-0.522,0.09s-0.219.054-.272,0.054a0.678,0.678,0,0,0-.108.018,0.516,0.516,0,0,0-.45.558v1.062h5.156v-1.062a0.532,0.532,0,0,0-.469-0.558,0.635,0.635,0,0,0-.109-0.018c-0.054,0-.142-0.036-0.27-0.054s-0.307-.054-0.522-0.09v-9.237h2.649c0.037,0.4.073,0.63,0.091,0.738a0.413,0.413,0,0,0,.432.342h1.028v-3.078h-0.288Z"
      transform="translate(-834.5 -853.719)"
    />
  </svg>;



// WEBPACK FOOTER //
// ./app/components/icons/font-icon.js